import { Box, Card, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import CreateNewProjectButton from './CreateNewProjectButton'

const imageSets = [
  ["./ModelTasks/InstanceSegmentation.png", "./ModelTasks/OrientedBoundingBox.png", "./ModelTasks/PoseEstimation.png"],
  ["./ModelTasks/BoundingBox.png", "./ModelTasks/SemanticSegmentation.png", "./ModelTasks/AnomalyDetection.png"]
]

const CreateNewProjectCardAnimated = ({ disabled = false }) => {
  const [currentSet, setCurrentSet] = useState(0)
  const [fade, setFade] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false) // start fade out
      setTimeout(() => {
        setCurrentSet(prev => (prev + 1) % imageSets.length)
        setFade(true) // fade back in
      }, 500) // match transition duration
    }, 7000) // change every 7 seconds
    return () => clearInterval(interval)
  }, [])

  return (
    <Card elevation={0} sx={{ border: '1px solid #cccccc', borderRadius: '12px', height: { xs: 'auto', sm: '20vh' } }}>
      <Box sx={{ 
        display: 'flex', 
        flexWrap: { xs: 'wrap', sm: 'nowrap' }, 
        height: { xs: 'auto', sm: '100%' }
      }}>
        <Box sx={{ flexBasis: { xs: '100%', sm: '31%' }, flexDirection: 'column', borderRadius: 1 }}>
          <Typography variant="h5" fontWeight="medium" sx={{ mt: 2, ml: 2 }}>
            Create a new project
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1, ml: 2, mb: 2 }}>
            Create your own AI model by uploading your data.
          </Typography>
          <Box sx={{ mt: 6, ml: 2}}>
            <CreateNewProjectButton disabled={disabled} />
          </Box>
        </Box>

        {imageSets[currentSet].map((src, index) => (
          <Box 
            key={index}
            sx={{ 
              flexBasis: { xs: '33.33%', sm: '23%' }, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              borderRadius: 1,
              minHeight: { xs: '120px', sm: 'auto' }
            }}
          >
            <img 
              src={src} 
              alt={`Project ${index}`} 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover', 
                borderRadius: '8px',
                opacity: fade ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out'
              }} 
            />
          </Box>
        ))}
      </Box>
    </Card>
  )
}

export default CreateNewProjectCardAnimated
